import type { FC } from "react";
import { getStaticProps } from "../../../methods/i18n";
import { useTranslation } from "next-i18next";
import SEO from "../../components/seo";
import { HeadScriptTag } from "../../components/HeadScriptTag";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import Footer from "../../components/Footer";
import ComplianceSection1 from "../../components/practice_areas/tax-compliance/ComplianceSection1";
import { ComplianceSection2 } from "../../components/practice_areas/tax-compliance/ComplianceSection2";
import { ComplianceSection3 } from "../../components/practice_areas/tax-compliance/ComplianceSection3";
import { ComplianceSection4 } from "../../components/practice_areas/tax-compliance/ComplianceSection4";
import { ComplianceSection5 } from "../../components/practice_areas/tax-compliance/ComplianceSection5";
import { ComplianceSection6 } from "../../components/practice_areas/tax-compliance/ComplianceSection6";
import { ComplianceSection7 } from "../../components/practice_areas/tax-compliance/ComplianceSection7";
import { ComplianceSection8 } from "../../components/practice_areas/tax-compliance/ComplianceSection8";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "LegalService",
  "name": "Tax Compliance Services",
  "url": " https://www.taxworkoutgroup.net/tax-compliance",
  "description": "Specialized legal services focusing delivering expert tax compliance, tax reporting, tax accounting and tax consulting and tax advisory services along with dedicated bookkeeping support.",
  "provider": {
    "@type": "Organization",
    "name": "Tax Workout Group",
    "url": "https://www.taxworkoutgroup.net",
    "logo": "https://www.taxworkoutgroup.net/_next/image?url=%2FTWGUpdatedLogo.png&w=640&q=75",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-561-571-2004",
      "contactType": "Customer Service",
      "areaServed": "US",
      "availableLanguage": ["English", "Spanish"]
    }
  },
  "serviceType": "Attorney",
  "areaServed": {
    "@type": "Country",
    "name": "United States"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "reviewCount": "96"
  }
}

export { getStaticProps };

const TaxComplianceGroup: FC = () => {
  const { t } = useTranslation("compliance, meta_tags");

  const title = t("meta_tags:tax_compliance");
  const description = t("meta_tags:tax_compliance_desc");
  const keywords = "Tax Compliance, Tax Reporting, Tax Accounting";
  const ogType = "website";
  const canonicalURL = "https://www.taxworkoutgroup.net/tax-compliance";
  return (
    <>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        ogType={ogType}
        canonicalURL={canonicalURL}
      />
      <HeadScriptTag />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(jsonLd)
        }}
      />
      <CustomBreadcrumb
        items={[
          {
            label: t("compliance:home"),
            href: "/",
          },
          {
            label: t("compliance:practice"),
            href: "/practice-areas",
          },
          {
            label: t("compliance:tax_compliance"),
            href: "/tax-compliance",
          },
        ]}
      />
      <ComplianceSection1 />
      <ComplianceSection2 />
      <ComplianceSection3 />
      <ComplianceSection4 />
      <ComplianceSection5 />
      <ComplianceSection6 />
      <ComplianceSection7 />
      <ComplianceSection8 />
      <Footer />
    </>
  );
};

export default TaxComplianceGroup;
